import { render, staticRenderFns } from "./StaticReport.vue?vue&type=template&id=4d19deca&scoped=true"
import script from "./StaticReport.vue?vue&type=script&lang=js"
export * from "./StaticReport.vue?vue&type=script&lang=js"
import style0 from "./StaticReport.vue?vue&type=style&index=0&id=4d19deca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19deca",
  null
  
)

export default component.exports